(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hsa-delivery-trust"] && !Shopify.designMode) return;
  try {
    class HsaPickupAvailability extends HTMLElement {
    connectedCallback() {
      this.sectionRoot = this.closest('.shopify-section, dialog');
      this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
      this.sectionRoot?.addEventListener('variant:update', this.handleVariantUpdate);
    }

    disconnectedCallback() {
      this.sectionRoot?.removeEventListener('variant:update', this.handleVariantUpdate);
      this.abortController?.abort();
    }

    handleVariantUpdate(event) {
      const variant = event.detail?.resource;
      if (!variant?.id || String(variant.id) === this.dataset.variantId) return;
      this.refresh(variant.id, variant.available);
    }

    async refresh(variantId, variantAvailable) {
      this.abortController?.abort();
      this.abortController = new AbortController();

      if (!variantAvailable) {
        this.hidden = true;
        return;
      }

      const url = new URL(this.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', this.dataset.sectionId);

      try {
        const response = await fetch(url, { signal: this.abortController.signal });
        if (!response.ok) throw new Error('Pickup availability request failed');

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const selector = `hsa-pickup-availability[data-variant-id="${CSS.escape(String(variantId))}"]`;
        const replacement = html.querySelector(selector);

        if (replacement) {
          this.replaceWith(replacement);
        } else {
          this.hidden = true;
          this.dataset.variantId = String(variantId);
        }
      } catch (error) {
        if (error.name !== 'AbortError') this.hidden = true;
      }
    }
  }

  if (!customElements.get('hsa-pickup-availability')) {
    customElements.define('hsa-pickup-availability', HsaPickupAvailability);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsa-laser-10591-product-reference"] && !Shopify.designMode) return;
  try {
    if (!window.hsaOrderGuideInitialized) {
    window.hsaOrderGuideInitialized = true;

    document.addEventListener('click', function (event) {
      var inboxButton = event.target.closest('[data-hsa-shopify-inbox-open]');

      if (inboxButton) {
        var openShopifyInbox = function (attempt) {
          var chat = document.querySelector('shopify-chat');
          var activator = chat && chat.shadowRoot
            ? chat.shadowRoot.querySelector('[part="activator"]')
            : null;

          if (activator) {
            activator.click();
            return;
          }

          if (attempt < 20) {
            window.setTimeout(function () {
              openShopifyInbox(attempt + 1);
            }, 100);
          }
        };

        openShopifyInbox(0);
        return;
      }

      var openButton = event.target.closest('[data-hsa-order-guide-open]');

      if (openButton) {
        var dialog = document.getElementById(openButton.getAttribute('aria-controls'));

        if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
          dialog.showModal();
        }

        return;
      }

      var readMoreLink = event.target.closest('[data-hsa-read-more]');

      if (readMoreLink) {
        var targetSelector = readMoreLink.getAttribute('href');
        var details = targetSelector ? document.querySelector(targetSelector) : null;

        // B2B guide products render their full details in a different Shopify section.
        if (!details) {
          details = document.querySelector('[id^="b2b-guide-details-"]');
        }

        if (details) {
          event.preventDefault();
          details.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        return;
      }

      if (event.target.matches('[data-hsa-order-guide-dialog]')) {
        event.target.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsa-product-reference-info"] && !Shopify.designMode) return;
  try {
    if (!window.hsaOrderGuideInitialized) {
    window.hsaOrderGuideInitialized = true;

    document.addEventListener('click', function (event) {
      var inboxButton = event.target.closest('[data-hsa-shopify-inbox-open]');

      if (inboxButton) {
        var openShopifyInbox = function (attempt) {
          var chat = document.querySelector('shopify-chat');
          var activator = chat && chat.shadowRoot
            ? chat.shadowRoot.querySelector('[part="activator"]')
            : null;

          if (activator) {
            activator.click();
            return;
          }

          if (attempt < 20) {
            window.setTimeout(function () {
              openShopifyInbox(attempt + 1);
            }, 100);
          }
        };

        openShopifyInbox(0);
        return;
      }

      var openButton = event.target.closest('[data-hsa-order-guide-open]');

      if (openButton) {
        var dialog = document.getElementById(openButton.getAttribute('aria-controls'));

        if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
          dialog.showModal();
        }

        return;
      }

      var readMoreLink = event.target.closest('[data-hsa-read-more]');

      if (readMoreLink) {
        var targetSelector = readMoreLink.getAttribute('href');
        var details = targetSelector ? document.querySelector(targetSelector) : null;

        // B2B guide products render their full details in a different Shopify section.
        if (!details) {
          details = document.querySelector('[id^="b2b-guide-details-"]');
        }

        if (details) {
          event.preventDefault();
          details.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        return;
      }

      if (event.target.matches('[data-hsa-order-guide-dialog]')) {
        event.target.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsa-quick-assistance"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.hsaQuickAssistanceInitialized) return;

    window.hsaQuickAssistanceInitialized = true;

    document.addEventListener('click', function (event) {
      var openButton = event.target.closest(
        '[data-hsa-how-to-order-open]'
      );

      if (openButton) {
        var dialogId = openButton.getAttribute('aria-controls');
        var dialog = document.getElementById(dialogId);

        if (
          dialog &&
          typeof dialog.showModal === 'function' &&
          !dialog.open
        ) {
          dialog.showModal();
        }

        return;
      }

      var closeButton = event.target.closest(
        '[data-hsa-how-to-order-close]'
      );

      if (closeButton) {
        var parentDialog = closeButton.closest(
          '[data-hsa-how-to-order-dialog]'
        );

        if (parentDialog) {
          parentDialog.close();
        }

        return;
      }

      if (
        event.target.matches(
          '[data-hsa-how-to-order-dialog]'
        )
      ) {
        event.target.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
